import { submitToNPSApi } from "./ApiCalls";

export const submitNPSData = (npsInfo, formKey) => {
  return (dispatch) => {
    if (!process.env.REACT_APP_USE_FIXTURES) {
      dispatch(submitToNPSApi({ ...npsInfo }, formKey));
    }
  };
};
